import React from "react";
import { Link } from "react-router-dom";
import "./integration.css"; // create a shared CSS for integration pages

function DiscordIntegration() {
  return (
    <div className="integration-container">
      <div className="integration-header">
        <h2>Discord Integration</h2>
        <Link to="/dashboard" className="back-link">← Back to Dashboard</Link>
      </div>

      <div className="integration-content">
        <p>Stay updated by sending real-time notifications from your smart contract events directly to Discord.</p>

        <h3>Setup Instructions</h3>
        <ol>
          <li>Create a Discord server or select an existing one.</li>
          <li>Create a webhook in your desired channel.</li>
          <li>Paste the webhook URL into your integration settings.</li>
          <li>Save and start receiving notifications!</li>
        </ol>

        <div className="integration-actions">
          <button className="copy-btn" onClick={() => navigator.clipboard.writeText("YOUR_DISCORD_WEBHOOK_URL")}>
            Copy Webhook URL
          </button>
          <a href="https://discord.com/developers/applications" target="_blank" rel="noopener noreferrer" className="btn external-btn">
            Go to Discord Developer Portal
          </a>
        </div>
      </div>
    </div>
  );
}

export default DiscordIntegration;
